import { isInteger } from '@impuls-coach/util-is';

export const getWeightForDisplay = (weight: number | string | undefined): string => {
	if (typeof weight !== 'number') {
		return '0';
	}

	if (isInteger(weight)) {
		return weight.toString();
	}

	return `${Math.round(weight * 10) / 10}`;
};
